<template>
  <div class="components__cnt-table_cause_frequencies">
    <table>
      <thead>
        <th>Anlässe</th>
        <th>(%)</th>
      </thead>
      <tbody>
        <tr>
          <td>
            <b>Husten mit/ohne Atemnot</b>
          </td>
          <td class="bracket-table_last">
            <b>30,2</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Akute Schmerzen</b>
            <table>
              <tr>
                <td>davon</td>
                <td>Hals-, und Mundschmerzen</td>
                <td>5,7%</td>
              </tr>
              <tr>
                <td></td>
                <td>Ohrenschmerzen</td>
                <td>4,1%</td>
              </tr>
              <tr>
                <td></td>
                <td>Kopf-, Bauch-, Muskel-/Skelettschmerzen</td>
                <td>5,6%</td>
              </tr>
            </table>
          </td>
          <td class="bracket-table_last">
            <b>15,4</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Fieber</b>
          </td>
          <td class="bracket-table_last">
            <b>13,3</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Haut-, Haar-, Nagelprobleme</b>
          </td>
          <td class="bracket-table_last">
            <b>13,1</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Durchfall u/o Erbrechen</b>
          </td>
          <td class="bracket-table_last">
            <b>8,2</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Beratungsanlass für den Bereich &bdquo;Neue Morbidität&ldquo;</b>
          </td>
          <td class="bracket-table_last">
            <b>7,2</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Rote u/o verklebte Augen</b>
          </td>
          <td class="bracket-table_last">
            <b>4,3</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Unfälle</b>
          </td>
          <td class="bracket-table_last">
            <b>2,3</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Probleme/Schmerzen beim Wasserlassen</b>
          </td>
          <td class="bracket-table_last">
            <b>1,6</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>
              Erkrankungen u/o Störungen in den einzelnen Organsystemen außer
              den oben bereits aufgeführten Vorstellungsanlässen
            </b>
          </td>
          <td class="bracket-table_last">
            <b>1,2</b>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="table-caption" colspan="2">
            <b>Tab. 2</b>
            Die 10 häufigsten akuten Vorstellungsanlässe
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.components__cnt-table_cause_frequencies {
  @import "~stylesheets/frontend/specific/content-widgets_tables";
}
</style>
